/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Lazy loading of the component PageHistoryOrder
 *
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.3.0
 */
import loadable from '../../utils/loadable';

export default loadable(() => import(/* webpackChunkName: "PageHistoryOrder" */ './PageHistoryOrder'), undefined);
